module.exports = __webpack_public_path__ + "static/img/mail-task.26ac1054.svg";